<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { DashWidgetTypes } from 'src/components/Dashboards/dash-types';
	import { getWidgetTypeDebug } from 'src/helpers/dev/widgetTypeDebug';
	import { widgetTypeOutlinesEnabled } from 'src/stores/features/dev/widget-type-outlines';

	let { type = '', children }: { type?: DashWidgetTypes | string; children?: Snippet } = $props();

	const debug = $derived(getWidgetTypeDebug(type));
	const isOn = $derived($widgetTypeOutlinesEnabled);
</script>

<div
	class={['widget-type-debug', isOn && 'is-on']}
	data-dash-widget-type={type}
	style:--widget-type-outline={debug.color}
>
	{#if isOn}
		<span class="widget-type-debug-tag">{debug.label}</span>
	{/if}
	{@render children?.()}
</div>

<style>
	.widget-type-debug:not(.is-on) {
		display: contents;
	}

	.widget-type-debug.is-on {
		position: relative;
		min-width: 0;
		outline: 2px dashed var(--widget-type-outline);
		outline-offset: 2px;
		border-radius: 12px;
	}

	.widget-type-debug-tag {
		position: absolute;
		top: 6px;
		left: 6px;
		z-index: 6;
		padding: 1px 6px;
		border-radius: 999px;
		background: var(--widget-type-outline);
		color: #111;
		font-size: 10px;
		font-weight: 700;
		letter-spacing: 0.04em;
		line-height: 1.4;
		text-transform: uppercase;
		pointer-events: none;
		white-space: nowrap;
	}
</style>
